import React from 'react';
import './defects.css';
import WarningIcon from '@mui/icons-material/Warning';
import { defectsData } from '../../data/defectsData';

const Defects = () => {
    const { header, cards } = defectsData;
  return (
    <div className="defects-section">
      <div className="defects-container">
        <div className="defects-header">
          <div className="defects-badge">
            <WarningIcon className="badge-icon" />
            <span>{header.badge.text}</span>
          </div>
          <h1 className="defects-title">{header.title}</h1>
          <p className="defects-description">
            {header.description}
          </p>
        </div>

        <div className="defects-grid">
          {cards.map((item, index) => (
            <div key={index} className="defect-card">
              <div className="defect-card-header">
                <div className="defect-icon-container" style={{ backgroundColor: item.color + '20' }}>
                  <div className="defect-icon-wrapper" style={{ color: item.color }}>
                    {item.icon}
                  </div>
                </div>
                <div className="defect-title-container">
                  <div className="defect-title-bar" style={{ backgroundColor: item.color }}></div>
                  <h3 className="defect-title">{item.title}</h3>
                </div>
              </div>
              
              <div className="defect-content">
                <p className="defect-description">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Defects;
